import { Entity } from '@backstage/catalog-model';
import {
  DATADOG_ANNOTATION_DASHBOARD_URL,
  DATADOG_ANNOTATION_GRAPH_TOKEN,
} from './components/useDatadogAppData';

export const isDatadogDashboardAvailable = (entity: Entity) =>
  Boolean(entity?.metadata.annotations?.[DATADOG_ANNOTATION_DASHBOARD_URL]);

export const isDatadogGraphAvailable = (entity: Entity) =>
  Boolean(entity?.metadata.annotations?.[DATADOG_ANNOTATION_GRAPH_TOKEN]);

export const isDatadogAvailable = (entity: Entity) =>
  isDatadogDashboardAvailable(entity) || isDatadogGraphAvailable(entity);
